import { render } from "./categorias.vue?vue&type=template&id=8c86f060"
import script from "./categorias.vue?vue&type=script&lang=js"
export * from "./categorias.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__